import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const NotificationOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
`;

const NotificationContent = styled.div`
    background: white;
    border-radius: 8px;
    padding: 1.5rem;
    max-width: 400px;
    width: 90%;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
`;

const NotificationHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    color: #dc3545;
    gap: 0.5rem;
`;

const Title = styled.h3`
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
`;

const Message = styled.p`
    margin: 0 0 1.5rem 0;
    color: #666;
    font-size: 0.875rem;
    line-height: 1.5;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
`;

const Button = styled.button`
    background: ${props => props.primary ? '#4AE66E' : '#e0e0e0'};
    color: ${props => props.primary ? 'white' : '#666'};
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background: ${props => props.primary ? '#3bc75d' : '#d0d0d0'};
    }
`;

const Notification = ({ isOpen, onClose, title, message, primaryAction }) => {
    if (!isOpen) return null;

    return (
        <NotificationOverlay>
            <NotificationContent>
                <NotificationHeader>
                    <FontAwesomeIcon icon={faExclamationCircle} />
                    <Title>{title}</Title>
                </NotificationHeader>
                <Message>{message}</Message>
                <ButtonContainer>
                    <Button onClick={onClose}>Close</Button>
                    {primaryAction && (
                        <Button primary onClick={primaryAction.onClick}>
                            {primaryAction.label}
                        </Button>
                    )}
                </ButtonContainer>
            </NotificationContent>
        </NotificationOverlay>
    );
};

export default Notification; 